// import React, { useRef, useEffect } from "react";
// import * as d3 from "d3";

// interface DataPoint {
//   label: string;
//   value: number;
// }

// interface LineChartProps {
//   data: DataPoint[];
//   width?: number;
//   height?: number;
//   lineColor?: string;
//   lineFillColor?: string;
// }

// const AreaLineChart: React.FC<LineChartProps> = ({
//   data,
//   width = 360,
//   height = 100,
//   lineColor = "#ADE7CB",
//   lineFillColor = "#EBF9F2",
//   ...rest
// }) => {
//   const svgRef = useRef<SVGSVGElement>(null);

//   useEffect(() => {
//     const svg = d3.select(svgRef.current);

//     svg.selectAll("*").remove();

//     const margin = { top: 5, left: 0 };
//     const chartWidth = width;
//     const chartHeight = height;

//     const x = d3
//       .scaleLinear()
//       .domain([0, data.length - 1])
//       .range([0, chartWidth]);

//     const y = d3
//       .scaleLinear()
//       //@ts-expect-error not applicable
//       .domain([0, d3.max(data, (d: DataPoint) => d.value)])
//       .range([chartHeight, 0]);

//     const line = d3
//       .line<DataPoint>()
//       .x((_: DataPoint, i: number) => x(i))
//       .y((d: DataPoint) => y(d.value));

//     const area = d3
//       .area<DataPoint>()
//       .x((_: DataPoint, i: number) => x(i))
//       .y0(chartHeight)
//       .y1((d: DataPoint) => y(d.value));

//     const chart = svg
//       .append("g")
//       .attr("transform", `translate(${margin.left},${margin.top})`);

//     chart
//       .append("path")
//       .datum(data)
//       .attr("class", "line")
//       .attr("d", line)
//       .style("fill", "none")
//       .style("stroke", lineColor)
//       .style("stroke-width", 5);

//     chart
//       .append("path")
//       .datum(data)
//       .attr("class", "area")
//       .attr("d", area)
//       .style("fill", lineFillColor);

//     chart.selectAll(".domain").remove();
//     chart.selectAll(".tick line").remove();
//   }, [data, height, lineColor, lineFillColor, width]);

//   return <svg ref={svgRef} width={width} height={height} {...rest}></svg>;
// };

// export default AreaLineChart;


import React, { useRef, useEffect } from "react";
import * as d3 from "d3";

interface DataPoint {
  label: string;
  value: number;
}

interface LineChartProps {
  data: DataPoint[];
  width?: number | string; // Adjusted to accept string for percentage width
  height?: number | string;
  lineColor?: string;
  lineFillColor?: string;
}

const AreaLineChart: React.FC<LineChartProps> = ({
  data,
  width = "auto", // Set default width to "100%"
  height = "auto",
  lineColor = "#ADE7CB",
  lineFillColor = "#EBF9F2",
  ...rest
}) => {
  const svgRef = useRef<SVGSVGElement>(null);

  useEffect(() => {
    const svg = d3.select(svgRef.current);

    svg.selectAll("*").remove();

    const margin = { top: 5, left: 0 };
    const chartWidth = typeof width === "number" ? width : svgRef.current?.parentElement?.clientWidth || 360; // Calculate width dynamically

    const chartHeight = height;

    const x = d3
      .scaleLinear()
      .domain([0, data.length - 1])
      .range([0, chartWidth]);

    const y = d3
      .scaleLinear()
      .domain([0, d3.max(data, (d: DataPoint) => d.value)])
      .range([chartHeight, 0]);

    const line = d3
      .line<DataPoint>()
      .x((_: DataPoint, i: number) => x(i))
      .y((d: DataPoint) => y(d.value));

    const area = d3
      .area<DataPoint>()
      .x((_: DataPoint, i: number) => x(i))
      .y0(chartHeight)
      .y1((d: DataPoint) => y(d.value));

    const chart = svg
      .append("g")
      .attr("transform", `translate(${margin.left},${margin.top})`);

    chart
      .append("path")
      .datum(data)
      .attr("class", "line")
      .attr("d", line)
      .style("fill", "none")
      .style("stroke", lineColor)
      .style("stroke-width", 5);

    chart
      .append("path")
      .datum(data)
      .attr("class", "area")
      .attr("d", area)
      .style("fill", lineFillColor);

    chart.selectAll(".domain").remove();
    chart.selectAll(".tick line").remove();
  }, [data, height, lineColor, lineFillColor, width]);

  return <svg ref={svgRef} width={width} height={height} {...rest}></svg>;
};

export default AreaLineChart;
